/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GolabAppLabDescription } from '../../models/golab-app-lab-description';

export interface GolabLabControllerGetGolabzLabList$Params {
}

export function golabLabControllerGetGolabzLabList(http: HttpClient, rootUrl: string, params?: GolabLabControllerGetGolabzLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GolabAppLabDescription>>> {
  const rb = new RequestBuilder(rootUrl, golabLabControllerGetGolabzLabList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GolabAppLabDescription>>;
    })
  );
}

golabLabControllerGetGolabzLabList.PATH = '/golab-lab/golabz-lab-list';
